<div class="animated fadeInRight" *ngIf="!ordenSelectedView">

  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="tituloGrid" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

   <!-- TEMPLATE PARA FILTROS -->
  <ng-template #templateFiltros>
    <form [formGroup]="frmFiltros" class="form-group" novalidate>
      <div class="row col-12">
        <div class="form-group col-md-3">
          <app-lfsa-input [control]="frmFiltros.get('orden') | formControl" [id]="'orden'" [isReadOnly]="false"
            [label]="'Ticket Balanza'" [mostrarImg]="false" [placeholder]="'Ticket Balanza'" [rutaImagen]="" [type]="'number'"
            formControlName="orden">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-3">
          <app-lfsa-input [control]="frmFiltros.get('inicio') | formControl" [id]="'inicio'" [label]="'Fecha Iinicio'"
            [mostrarImg]="false" [placeholder]="'inicio'" [rutaImagen]="" [type]="'date'" formControlName="inicio">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-3">
          <app-lfsa-input [control]="frmFiltros.get('fin') | formControl" [id]="'fin'" [label]="'Fecha Fin'"
            [mostrarImg]="false" [placeholder]="'fin'" [rutaImagen]="" [type]="'date'" formControlName="fin">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-3 align-middle">          
          <label></label>
          <button (click)="buscarDesbloqueos()" class="btn btn-success btn-block">Buscar</button>          
        </div>        
      </div>
    </form>
  </ng-template>
  <!-- TEMPLATE PARA FILTROS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <app-lfsa-card [innTemplate]="templateFiltros" [titulo]="'Filtrar histórico'" [banderaColapse]="false" [efecto]="true">
    </app-lfsa-card>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [id]="'desblqueo-seleccionado'"
  [idClose]="'cerrarModal'" [innTemplate]="abrirModal" [titulo]="tituloModal"></app-lfsa-modal>

<ng-template #abrirModal>
  <div *ngIf="ordenSelected && !ordenSelectedView">
    <div style="display: flex;justify-content: end;">
      <div style="padding: 3px 5px;background-color: rgb(255, 120, 120);">{{ dataEditar.tipo }}</div>
    </div>
    <div class="container-fluid">
      <form [formGroup]="agregarForm" mat-dialog-content>
        <div class="row">
          <div class="col-6 mb-2">
            <label for="idOrden">Orden de Balanza</label>
            <input class="form-control" formControlName="idOrden" id="idOrden" readonly type="text">
            <small *ngIf="agregarForm.controls['idOrden'].errors && agregarForm.controls['idOrden'].touched"
              class="text-danger">*Este campo es inválido</small>
          </div>
          <div class="col-5 mb-2">
            <label for="tipo">Tipo de Orden</label>
            <input class="form-control" formControlName="tipo" id="tipo" type="text">
            <small *ngIf="agregarForm.controls['tipo'].errors && agregarForm.controls['tipo'].touched"
              class="text-danger">*Este campo es inválido</small>
          </div>

          <div class="col-6 mb-2">
            <label for="proveedor">Proveedor</label>
            <input class="form-control" formControlName="proveedor" id="proveedor" type="text" readonly>
          </div>
          <div class="col-5 mb-2">
            <label for="material">Material</label>
            <input class="form-control" formControlName="material" id="material" type="text" readonly>
          </div>

          <div class="col-1 mb-2" style="display: flex;align-items: end;">
            <button (click)="verOB()" class="btn btn-outline-info" style="width: 100%;">
              <i aria-hidden="true" class="fa fa-eye"></i>
              Ver
            </button>
          </div>
          <div class="col-12 mb-2" *ngIf="BLOQUEADO_DIF_CALIDAD">
            BLOQUEOS POR CALIDAD
            <div class="row" style="border: 1px solid rgb(0, 146, 0);border-radius: 10px;">
              <div class="col-6 mb-2 mt-3">
                <label for="loteInsp">Lote de Inspección SAP</label>
                <input class="form-control" formControlName="loteInsp" id="loteInsp" readonly type="text">
                <small *ngIf="agregarForm.controls['loteInsp'].errors && agregarForm.controls['loteInsp'].touched"
                  class="text-danger">*Este campo es inválido</small>
              </div>
              <div class="col-12 mb-2">

                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Recibida</th>
                      <th scope="col">SAP</th>
                      <th scope="col">Diferencias</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Acidez</th>
                      <td><input class="form-control" formControlName="acidez" id="acidez" readonly type="text"></td>
                      <td><input class="form-control" formControlName="acidezSap" id="acidezSap" readonly type="text">
                      </td>
                      <td><input class="form-control" formControlName="difAcidez" id="difAcidez" type="text"></td>
                    </tr>
                    <tr>
                      <th scope="row">Humedad</th>
                      <td><input class="form-control" formControlName="humedad" id="humedad" readonly type="text"></td>
                      <td><input class="form-control" formControlName="humedadSap" id="humedadSap" readonly type="text"></td>
                      <td><input class="form-control" formControlName="difHumedad" id="difHumedad" type="text"></td>
                    </tr>
                    <tr>
                      <th scope="row">Impureza</th>
                      <td><input class="form-control" formControlName="impureza" id="impureza" readonly type="text"></td>
                      <td><input class="form-control" formControlName="impurezaSap" id="impurezaSap" readonly type="text"></td>
                      <td><input class="form-control" formControlName="difImpureza" id="difImpureza" type="text"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-12 mb-2" *ngIf="!BLOQUEADO_DIF_CALIDAD">
            BLOQUEOS POR PESO SALIDA
            <div class="row" style="border: 1px solid rgb(0, 146, 0);border-radius: 10px;">
              <div class="col-12 mb-2">
              <!-- 06-09-2023 KD: field peso neto balanza, recibido y tipo tolerancia - testing -->
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Peso Entrada</th>
                      <th scope="col">Peso Salida</th>
                      <th scope="col">Peso Neto Balanza</th>
                      <th scope="col">Recibido (prov. o flete)</th>
                      <th scope="col">Tolerancia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Pesaje balanza</th>
                      <td><input class="form-control" formControlName="pesoIn" id="pesoIn" readonly type="text"></td>
                      <td><input class="form-control" formControlName="pesoOut" id="pesoOut" readonly type="text"></td>
                      <td><input class="form-control" formControlName="pesoNetoBalanza" id="pesoNetoBalanza" readonly type="text"></td>
                      <td><input class="form-control" formControlName="pesoNeto" id="pesoNeto" readonly type="text"></td>
                      <td><input class="form-control" formControlName="tolerancia" id="tolerancia" type="text"> {{tipoTolerancia}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-12 mb-2">
            REGISTRO DE DESBLOQUEOS
            <div class="row" style="border: 1px solid rgb(0, 146, 0);border-radius: 10px;">
              <div class="col-12 mb-2">

                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Nivel</th>
                      <th scope="col">Tipo</th>
                      <th scope="col">Fecha y Hora Desbloqueo</th>
                      <th scope="col">Autoriza</th>
                      <th scope="col">Usuario Autoriza</th>
                      <th scope="col">Usuario Ejecuta</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><input class="form-control" formControlName="nivel" id="nivel" readonly type="text"></td>
                      <td><input class="form-control" formControlName="tipoSap" id="tipoSap" readonly type="text"></td>
                      <td><input class="form-control" formControlName="fechaActual" id="fechaActual" type="text"></td>
                      <td>
                        <select formControlName="autoriza" name="autoriza" id="autoriza" class="form-control">
                          <option value="SI">SI</option>
                          <option value="NO">NO</option>
                        </select>
                      </td>
                      <td>
                        <div class="col-lg-12 mb-2 position-relative">
                          <div class="d-flex">
                            <input class="form-control" formControlName="usuarioAutoriza" id="usuarioAutoriza"
                              type="text">
                            <button (click)="searchUsers()" class="btn btn-success" type="button">
                              <i class="fa fa-bars"></i>
                            </button>
                          </div>
                          <div *ngIf="showUsers" class="combo-box-custom shadow"
                            style="position: absolute;
                                                                                      z-index: 9;
                                                                                      background: white;
                                                                                      border-radius: 10px;
                                                                                      border: 1px solid lightgray;
                                                                                      box-shadow: 0px 0px 10px 15px black;
                                                                                      box-shadow: 0 0 10px lightgray !important;">
                            <!--<div (click)="selectedUser(cmb)"
                              *ngFor="let cmb of cmbUsuarios | searchCmbBox:agregarForm.get('usuarioAutoriza').value"
                              class="px-3 py-2">{{cmb.id}} - {{cmb.nombre}}</div>-->
                              <div (click)="selectedUser(cmb)"
                              *ngFor="let cmb of cmbUsuarios"
                              class="px-3 py-2">{{cmb.id}} - {{cmb.nombre}}</div>
                          </div>
                        </div>
                      </td>
                      <td><input class="form-control" formControlName="usuarioCaptura" id="usuarioCaptura" readonly
                          type="text"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div>
          <label for="">Motivo</label>
          <select class="form-control" formControlName="motivo" name="motivo">
            <option value="">-- seleccione --</option>
            <option *ngFor="let motivo of motivosCmb" [value]="motivo.description">{{motivo.description}}</option>
          </select>
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('motivo')?.hasError('required')">
                El campo Motivo es requerido.
              </div>
            </small>
          </div>
        </div>
        <div class="mb-3">
          <div class="form-group">
            <label for="message-text" class="control-label">Observaciones:</label>
            <textarea class="form-control" formControlName="observacion" id="observacion"></textarea>
          </div>
        </div>
        
        <div>
          <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
          [loading]="loading" [textBoton]="'Guardar'" class="row" [mostrarBotonVerde]="isCreate">
          </app-lfsa-botones-formulario>
        </div>
        
      </form>
    </div>
  </div>
</ng-template>
<!-- END MODAL -->
















<!-- MODAL SELECCION DE ORDEN DE BALANZA -->

<div *ngIf="ordenSelectedView" class="container-fluid" style="background-color: white;">
  <form [formGroup]="ordenBalanzaForm">
    <div class="row mb-2 p-3 border rounded">
      <div class="alert alert-secondary d-flex justify-content-between" role="alert">
        <div>Mantenimiento de Ordenes de Balanza</div>
        <div class="d-flex justify-content-end rounded bg-info px-3 text-white">ESTADO ORDEN BALANZA: {{ status }}
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="col-lg-6 mb-2">
            <label for="">Orden de Balanza</label>
            <input class="form-control" formControlName="idOrden" name="idOrden" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('idOrden')?.hasError('required')">
                  El campo Fecha es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Fecha</label>
            <input class="form-control" formControlName="fecha" name="fecha" readonly type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('idOrden')?.hasError('required')">
                  El campo Fecha es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <!-- <label for="">Tipo de Orden</label> -->
            <!-- <input type="text" class="form-control" formControlName="tipo"> -->
            <label for="">Tipo de Orden</label>
            <input class="form-control" formControlName="tipo" name="tipo" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('tipo')?.hasError('required')">
                  El campo Tipo de Orden es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Número de Orden</label>
            <input class="form-control" formControlName="numero" name="numero" type="text">
            <div class="text-muted">
              <small><small>Compra/Venta, Traslados, Maquila</small></small>
            </div>
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('numero')?.hasError('required')">
                  El campo Número de Orden es requerido.
                </div>
              </small>
            </div>
          </div>
          <div *ngIf="this.showIngresoVacio" class="col-lg-6 mb-2 d-flex">
            <label class="mb-2" for="emptyIncome" style="margin-right: 15px;">
              Ingreso Vacio
            </label>
            <div class="form-check">
              <input class="form-check-input" formControlName="emptyIncome" id="emptyIncome" type="checkbox">
              <label class="form-check-label" for="emptyIncome">
                {{this.ordenBalanzaForm.get('emptyIncome') && this.ordenBalanzaForm.get('emptyIncome').value ? 'Si' :
                'No'}}
              </label>
            </div>
          </div>
          <!-- <div class="col-lg-6 mb-2">
            <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('freightNumber') | formControl"
              [id]="'freightNumber'" [isReadOnly]="true" [label]="'Número de Flete'" [mostrarImg]="false"
              [placeholder]="'Número de Flete'" [rutaImagen]="" [type]="'text'" formControlName="freightNumber">
            </app-lfsa-input>
          </div> -->


          <div class="col-lg-6 mb-2">
            <label for="">Factura</label>
            <input class="form-control" formControlName="factura" name="factura" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('factura')?.hasError('required')">
                  El campo Factura es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Guía</label>
            <input class="form-control" formControlName="guia" name="guia" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('guia')?.hasError('required')">
                  El campo Guía es requerido.
                </div>
              </small>
            </div>
          </div>
          <!-- <div class="col-lg-6 mb-2">
            <label for="">Proveedor</label>
            <input class="form-control" formControlName="proveedor" name="proveedor" type="text">
            <div
              class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('proveedor')?.hasError('required')">
                  El campo Proveedor es requerido.
                </div>
              </small>
            </div>
          </div> -->
          <div class="col-6">
            <div class="mb-2">
              <label for="">Proveedor</label>
              <input (change)="onChangeProveedor($event);" (keyup)="onChangeProveedor($event);" autocomplete="off"
                class="form-control" formControlName="proveedor" name="proveedor" type="text">
            </div>
            <div *ngIf="proveedorInvalido" class="text-danger">
              <small>*Este proveedor es inválido</small>
            </div>
            <small class="text-danger">
              <div *ngIf="ordenBalanzaForm.get('proveedor')?.hasError('required')">
                El campo proveedor es requerido.
              </div>
            </small>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Proveedor</label>
              <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly
                type="text">
            </div>
          </div>

          <!-- <div class="col-lg-6 mb-2">
            <label for="">Cliente</label>
            <input class="form-control" formControlName="cliente" name="cliente" type="text">
            <div
              class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('cliente')?.hasError('required')">
                  El campo Cliente es requerido.
                </div>
              </small>
            </div>
          </div> -->
          <div class="col-6">
            <div class="mb-2">
              <label for="">Cliente</label>
              <input (change)="onChangeCliente($event);" (keyup)="onChangeCliente($event);" autocomplete="off"
                class="form-control" formControlName="cliente" name="cliente" type="text">
            </div>
            <div *ngIf="clienteInvalido" class="text-danger">
              <small>*Este cliente es inválido</small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Cliente</label>
              <input autocomplete="off" class="form-control" formControlName="descli" name="descli" readonly
                type="text">
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Orden de Balanza Origen</label>
            <input class="form-control" formControlName="ordBalanzaOrigen" name="ordBalanzaOrigen" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('ordBalanzaOrigen')?.hasError('required')">
                  El campo Orden de Balanza Origen es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Peso de O.Balanza Origen</label>
            <input class="form-control" formControlName="pesoBalanzaOrigen" name="pesoBalanzaOrigen" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('pesoBalanzaOrigen')?.hasError('required')">
                  El campo Peso de O.Balanza Origen es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Sellos</label>
            <input class="form-control" formControlName="sellos" name="sellos" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('sellos')?.hasError('required')">
                  El campo Sellos es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-6 mb-2">
            <label for="">Contenedor/Recurso</label>
            <input class="form-control" formControlName="contenedor" name="contenedor" type="text">
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('contenedor')?.hasError('required')">
                  El campo Contenedor es requerido.
                </div>
                <div *ngIf="ordenBalanzaForm.get('contenedor')?.hasError('pattern')">
                  *Máximo 12 caracteres
                </div>
              </small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Material</label>
              <input (change)="onChangeMaterial($event)" (keyup)="onChangeMaterial($event);" autocomplete="off"
                class="form-control" formControlName="material" name="material" type="text">
              <div *ngIf="materialInvalido" class="text-danger">
                <small>*Este material es inválido</small>
              </div>
              <small class="text-danger">
                <div *ngIf="ordenBalanzaForm.get('material')?.hasError('required')">
                  El campo material es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Material</label>
              <input autocomplete="off" class="form-control" formControlName="desmat" name="desmat" readonly
                type="text">
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="row border">
          <div class="text-center border-bottom py-1">
            INFO DEL TICKET DE AUTORIZACIÓN DE TRANSPORTE
          </div>
          <div class="row py-3">
            <div class="col-lg-6 mb-2">
              <label for="">Digite Ticket Autorización</label>
              <input class="form-control" formControlName="ticketAuth" name="ticketAuth" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('ticketAuth')?.hasError('required')">
                    El campo Ticket Autorización Transporte es requerido.
                  </div>
                </small>
              </div>
              <!-- <small *ngIf="digiteTicketAutorizacionDuplicated" class="text-danger">
                <div>
                  Este código de Ticket Autorización ya fue registrado.
                </div>
              </small> -->
            </div>
            <div class="col-lg-6 mb-2">
              <!-- <button *ngIf="isCreate" (click)="buscarPlacaTransporte()" type="button"
                class="btn btn-success">Buscar</button> -->
              <label for="">Placa</label>
              <input class="form-control" formControlName="placa" name="placa" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('placa')?.hasError('required')">
                    El campo Digite Placa es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="mb-2  ">
              <label for="">Datos Transportista</label>
            </div>
            <div class="col-lg-6 mb-2">
              <label for="">Chofer</label>
              <input class="form-control" formControlName="chofer" name="chofer" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('chofer')?.hasError('required')">
                    El campo Chofer es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Cédula</label>
              <input class="form-control" formControlName="cedChofer" name="cedChofer" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('cedChofer')?.hasError('required')">
                    El campo Cédula es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-2 mb-2 d-flex justify-content-start align-items-end">
              <button (click)="openModal()" [disabled]="!placaResponse?.codigo" class="btn btn-info text-white"
                type="button">Ver <i aria-hidden="true" class="fa fa-eye"></i></button>
            </div>
          </div>
        </div>
        <div class="row border mt-3 py-3">
          <div class="col-lg-2 mb-2 d-flex align-items-end mb-3">
            ORIGEN
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Centro</label>
            <select class="form-control" formControlName="centroOri" name="centroOri">
              <option value="">-- seleccione --</option>
              <option *ngFor="let cen of centrosCmb" [value]="cen.idCentro">{{cen.nombreCentro}}</option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('centroOri')?.hasError('required')">
                  El campo Centro es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Almacén</label>
            <select class="form-control" formControlName="almanceOri" name="almanceOri">
              <option value="">-- seleccione --</option>
              <option *ngFor="let alm of almacenesCmb" [value]="alm.idAlmacen">{{alm.dscaAlmacen}}</option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('almanceOri')?.hasError('required')">
                  El campo Almacén es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-2 mb-2 d-flex align-items-end mb-3">
            DESTINO
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Centro</label>
            <select class="form-control" formControlName="centroDest" name="centroDest">
              <option value="">-- seleccione --</option>
              <option *ngFor="let cen of centrosCmb" [value]="cen.idCentro">{{cen.nombreCentro}}</option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('centroDest')?.hasError('required')">
                  El campo Centro es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-5 mb-2">
            <label for="">Almacén</label>
            <select class="form-control" formControlName="almaceDest" name="almaceDest">
              <option value="">-- seleccione --</option>
              <option *ngFor="let alm of almacenesCmb" [value]="alm.idAlmacen">{{alm.dscaAlmacen}}</option>
            </select>
            <div class="text-danger">
              <small>
                <div *ngIf="ordenBalanzaForm.get('almaceDest')?.hasError('required')">
                  El campo Almacén es requerido.
                </div>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-secondary mt-3" role="alert">
        Datos recibidos del proveedor
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="border-bottom mb-2">DATOS RECIBIDOS</div>
          <div class="row">
            <div class="col-lg-3 mb-2">
              <label for="">Origen</label>
              <input class="form-control" formControlName="origOrd" name="origOrd">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('origOrd')?.hasError('required')">
                    El campo Origen es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="">Peso bruto</label>
              <input class="form-control" formControlName="pesoBruto" name="pesoBruto" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('pesoBruto')?.hasError('required')">
                    El campo Peso bruto es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="">Peso neto</label>
              <input class="form-control" formControlName="pesoNeto" name="pesoNeto" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('pesoNeto')?.hasError('required')">
                    El campo Peso neto es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-3 mb-2">
              <label for="">Peso Tara</label>
              <input class="form-control" formControlName="tara" name="tara" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('tara')?.hasError('required')">
                    El campo Tara es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="border-bottom mb-2">CALIDAD RECIBIDA</div>
          <div class="row">
            <div class="col-lg-4 mb-2">
              <label for="">Acidez</label>
              <input class="form-control" formControlName="acidez" name="acidez" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('acidez')?.hasError('required')">
                    El campo Acidez es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Humedad</label>
              <input class="form-control" formControlName="humedad" name="humedad" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('humedad')?.hasError('required')">
                    El campo Humedad es requerido.
                  </div>
                </small>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label for="">Impureza</label>
              <input class="form-control" formControlName="impureza" name="impureza" type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('impureza')?.hasError('required')">
                    El campo Impureza es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-secondary mt-3 d-flex" role="alert">
        <div class="w-50 d-flex align-items-center">
          <span> Orden de Compra SAP</span>
        </div>
        <div class="w-50 d-flex justify-content-end align-items-center">
        </div>
      </div>
      <div class="row border m-0">
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('ocStatus') | formControl" [id]="'ocStatus'"
            [isReadOnly]="true" [label]="'ESTADO'" [mostrarImg]="false" [placeholder]="'ESTADO'" [rutaImagen]=""
            [type]="'text'" formControlName="ocStatus">
          </app-lfsa-input>
        </div>
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('solpedNumber') | formControl"
            [id]="'solpedNumber'" [isReadOnly]="true" [label]="'N# SOLPED'" [mostrarImg]="false"
            [placeholder]="'N# SOLPED'" [rutaImagen]="" [type]="'text'" formControlName="solpedNumber">
          </app-lfsa-input>
        </div>
        <div class="col-lg-2">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('ocNumber') | formControl" [id]="'ocNumber'"
            [isReadOnly]="true" [label]="'N# OC'" [mostrarImg]="false" [placeholder]="'N# OC'" [rutaImagen]=""
            [type]="'text'" formControlName="ocNumber">
          </app-lfsa-input>
        </div>
        <div class="col-lg-3">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('creationDateOC') | formControl"
            [id]="'creationDateOC'" [isReadOnly]="true" [label]="'FECHA CREACION'" [mostrarImg]="false"
            [placeholder]="'FECHA CREACION'" [rutaImagen]="" [type]="'text'" formControlName="creationDateOC">
          </app-lfsa-input>
        </div>
        <div class="col-lg-3">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('updateDateOC') | formControl"
            [id]="'updateDateOC'" [isReadOnly]="true" [label]="'FECHA ACTUALIZACION'" [mostrarImg]="false"
            [placeholder]="'FECHA ACTUALIZACION'" [rutaImagen]="" [type]="'text'" formControlName="updateDateOC">
          </app-lfsa-input>
        </div>
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Información del lote de inspección
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="">
          <label for="">Número Lote</label>
          <input class="form-control" formControlName="loteInsp" name="loteInsp" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="ordenBalanzaForm.get('loteInsp')?.hasError('required')">
                El campo Número Lote es requerido.
              </div>
            </small>
          </div>
        </div>
        <div class="">
          <label for="">GRADO API</label>
          <input class="form-control" formControlName="gradoApi" name="gradoApi"
            type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="ordenBalanzaForm.get('gradoApi')?.hasError('required')">
                El campo GRADO API es requerido.
              </div>
            </small>
          </div>
        </div>

        <div class="">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('inspectionLotAcidity') | formControl"
            [id]="'inspectionLotAcidity'" [isReadOnly]="true" [label]="'Acidez'" [mostrarImg]="false"
            [placeholder]="'Acidez'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotAcidity">
          </app-lfsa-input>
        </div>
        <div class="">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('inspectionLotMoisture') | formControl"
            [id]="'inspectionLotMoisture'" [isReadOnly]="true" [label]="'Humedad'" [mostrarImg]="false"
            [placeholder]="'Humedad'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotMoisture">
          </app-lfsa-input>
        </div>
        <div class="">
          <app-lfsa-input [addon]="false" [control]="ordenBalanzaForm.get('inspectionLotImpurity') | formControl"
            [id]="'inspectionLotImpurity'" [isReadOnly]="true" [label]="'Impureza'" [mostrarImg]="false"
            [placeholder]="'Impureza'" [rutaImagen]="" [type]="'text'" formControlName="inspectionLotImpurity">
          </app-lfsa-input>
        </div>

        <div class="">
          <label for="">Decisión de Empleo</label>
          <input class="form-control" formControlName="decisionEmpleo" name="decisionEmpleo" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="ordenBalanzaForm.get('decisionEmpleo')?.hasError('required')">
                El campo Decisión de Empleo es requerido.
              </div>
            </small>
          </div>
        </div>
        <!-- <div class="">
          <label for="">Estatus de calidad</label>
          <input class="form-control" formControlName="calidad" name="calidad" type="text">
          <div class="text-danger">
            <small>
              <div *ngIf="agregarForm.get('calidad')?.hasError('required')">
                El campo Estatus de calidad es requerido.
              </div>
            </small>
          </div>
        </div> -->
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Captura de pesos Entrada/Salida
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="d-flex justify-content-between">
            <div>CAPTURA DE PESOS ENTRADA</div>
            <div>
              <i (click)="imprimirCapturaEntrada()" *ngIf="!imprimirCapturaEntradaLoading" aria-hidden="true"
                class="fa fa-print text-muted" style="cursor: pointer;"></i>
              <i *ngIf="imprimirCapturaEntradaLoading" class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <div class="row border py-3">
              <div class="col-lg-3">
                <div class="">
                  <label for="">Fecha entrada</label>
                  <input class="form-control" formControlName="fechIn" name="fechIn" type="text">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="ordenBalanzaForm.get('fechIn')?.hasError('required')">
                        El campo Fecha entrada de calidad es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Hora entrada</label>
                  <input class="form-control" formControlName="horaEntrada" name="horaEntrada" type="time">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="ordenBalanzaForm.get('horaEntrada')?.hasError('required')">
                        El campo Hora entrada es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Peso entrada</label>
                  <input class="form-control" formControlName="pesoIn" name="pesoIn" type="text">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="ordenBalanzaForm.get('pesoIn')?.hasError('required')">
                        El campo Peso entrada es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-end">
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 px-3">
          <div class="d-flex justify-content-between">
            <div>CAPTURA DE PESOS SALIDA</div>
            <div>
              <i (click)="imprimirCapturaSalida()" *ngIf="!imprimirCapturaSalidaLoading" aria-hidden="true"
                class="fa fa-print text-muted" style="cursor: pointer;"></i>
              <i *ngIf="imprimirCapturaSalidaLoading" class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <div class="row border py-3">
              <div class="col-lg-3">
                <div class="">
                  <label for="">Fecha salida</label>
                  <input class="form-control" formControlName="fechOut" name="fechOut" type="text">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="ordenBalanzaForm.get('fechOut')?.hasError('required')">
                        El campo Fecha salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Hora salida</label>
                  <input class="form-control" formControlName="horaSalida" name="horaSalida" type="time">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="ordenBalanzaForm.get('horaSalida')?.hasError('required')">
                        El campo Hora salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="">
                  <label for="">Peso salida</label>
                  <input class="form-control" formControlName="pesoOut" name="pesoOut" type="text">
                  <div class="text-danger">
                    <small>
                      <div *ngIf="ordenBalanzaForm.get('pesoOut')?.hasError('required')">
                        El campo Peso salida es requerido.
                      </div>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 d-flex justify-content-center align-items-end">
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="alert alert-secondary mt-3" role="alert">
        Información de la Balanza
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="d-flex justify-content-center align-items-center">
            <div class="">
              <label for="">SU BALANZA</label>
              <input class="form-control" formControlName="ordenFijaDescription" name="ordenFijaDescription" readonly
                type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('ordenFijaDescription')?.hasError('required')">
                    El campo SU BALANZA es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="d-flex justify-content-center align-items-center">
            <div class="">
              <label for="">USUARIO ACTUAL</label>
              <input class="form-control" formControlName="usuario" name="usuario" readonly type="text">
              <div class="text-danger">
                <small>
                  <div *ngIf="ordenBalanzaForm.get('usuario')?.hasError('required')">
                    El campo USUARIO ACTUAL es requerido.
                  </div>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <button (click)="regresarDesbloqueo()" class="btn btn-success">Regresar</button>
  </form>
</div>
<!-- END MODAL -->